import { Dropdown, DropdownMenu, DropdownItem } from "reactstrap";
import { useNavigate } from "react-router-dom";

import useFetch from "Hooks/useFetch";
import useAlertContext from "Hooks/useAlertContext";
import useHelpers from "Hooks/useHelpers";

export default function RunContextMenu({
    visible,
    toggle,
    row,
    x,
    y,
}: {
    visible: boolean;
    toggle: () => void;
    row: IMessageHeader;
    x: number;
    y: number;
}) {
    const { newAlert } = useAlertContext();
    const { post } = useFetch();
    const navigate = useNavigate();
    const {
        abandonJob,
        cancelJob,
        canRerunAll,
        canAbandonJobs,
        replacePlussesWithSpaces,
    } = useHelpers();

    async function runIntegration(debug: string = ""): Promise<void> {
        const method_info = replacePlussesWithSpaces(row.method_info);

        let url = `/api/jobqueue/${method_info}`;

        while (url.endsWith("/DEBUG")) {
            url = url.split("/").slice(0, -1).join("/");
        }
        if (debug) {
            url += "/DEBUG";
        }

        const response = await post(url);

        const data = await response.json();
        console.log(data);

        if (response.ok) {
            newAlert({
                color: "info",
                message: "Rerun job request sent.",
            });
        } else {
            newAlert({
                color: "danger",
                message: `Rerun job request failed: ${data.detail}`,
            });
        }
    }

    const canRerun =
        row && row.initiator !== undefined ? canRerunAll(row.initiator) : false;

    return (
        <Dropdown
            isOpen={visible}
            toggle={toggle}
            style={{
                position: "absolute",
                zIndex: 100,
                left: x,
                top: y,
            }}
        >
            <DropdownMenu>
                {canRerun && (
                    <>
                        <DropdownItem onClick={() => runIntegration("/DEBUG")}>
                            Run Again in Preview Mode
                        </DropdownItem>
                        <DropdownItem onClick={() => runIntegration()}>
                            Run Again in Live Mode
                        </DropdownItem>
                    </>
                )}
                <DropdownItem onClick={() => cancelJob(row.id)}>
                    Request Cancelation
                </DropdownItem>
                {canAbandonJobs() && (
                    <DropdownItem onClick={() => abandonJob(row.id)}>
                        Mark as Abandoned
                    </DropdownItem>
                )}
            </DropdownMenu>
        </Dropdown>
    );
}
